import { FC } from "react";
import { PartnerTypeEnum } from "Enums";
import { BorderedIconedTextblock } from "../BorderedIconedTextblock";
import { faBuilding, faIndustry, faUniversity } from "@fortawesome/free-solid-svg-icons";

type TPartnerTypeBoxProps = {
    partnerType: PartnerTypeEnum
}

export const PartnerTypeBox: FC<TPartnerTypeBoxProps> = ({partnerType} : TPartnerTypeBoxProps) => {

    switch (partnerType) {
        case PartnerTypeEnum.University:
            return (<BorderedIconedTextblock icon={faUniversity} text="University" />);
        case PartnerTypeEnum.ResearchInstitute:
            return (<BorderedIconedTextblock icon={faBuilding} text="Research Institute" />);
        case PartnerTypeEnum.Company:
            return (<BorderedIconedTextblock icon={faIndustry} text="Company" />);
        default:
            return (<></>);
    }
}